import View from './sub-navigation-view';

export default View;
